import { render, staticRenderFns } from "./HostingSwitch.vue?vue&type=template&id=014928ad&"
import script from "./HostingSwitch.vue?vue&type=script&lang=js&"
export * from "./HostingSwitch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('014928ad')) {
      api.createRecord('014928ad', component.options)
    } else {
      api.reload('014928ad', component.options)
    }
    module.hot.accept("./HostingSwitch.vue?vue&type=template&id=014928ad&", function () {
      api.rerender('014928ad', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Services/HostingSwitch.vue"
export default component.exports